// extracted by mini-css-extract-plugin
export default {"app":"AboutPage_app__594Ic","h1":"AboutPage_h1__pNSOA","paragraph":"AboutPage_paragraph__Wo6WQ","centered":"AboutPage_centered__E2tO9"};